module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.sectionsList), function(sectionName, index) {
    return _c('home-section', {
      key: sectionName,
      attrs: {
        "id": index + 1,
        "name": sectionName,
        "content-props": _vm.contentList[index + 1],
        "loading": _vm.isLoading
      }
    })
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Featured Content")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-202a6114","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/featuredContent/Index.vue
// module id = 838
// module chunks = 0